import React from 'react'
import { iconProps } from '../Helper'

export const LockIcon = ({ className }: iconProps) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Lock-light">
            <path className={className} id="Vector" d="M8.00033 0.666016C5.78445 0.666016 4.00033 2.45014 4.00033 4.66602V5.33268C3.26699 5.33268 2.66699 5.93268 2.66699 6.66602V13.3327C2.66699 14.066 3.26699 14.666 4.00033 14.666H12.0003C12.7337 14.666 13.3337 14.066 13.3337 13.3327V6.66602C13.3337 5.93268 12.7337 5.33268 12.0003 5.33268V4.66602C12.0003 2.45014 10.2162 0.666016 8.00033 0.666016ZM8.00033 1.99935C9.51779 1.99935 10.667 3.14856 10.667 4.66602V5.33268H5.33366V4.66602C5.33366 3.14856 6.48286 1.99935 8.00033 1.99935ZM8.00033 8.66602C8.73366 8.66602 9.33366 9.26602 9.33366 9.99935C9.33366 10.7327 8.73366 11.3327 8.00033 11.3327C7.26699 11.3327 6.66699 10.7327 6.66699 9.99935C6.66699 9.26602 7.26699 8.66602 8.00033 8.66602Z" fill="#929090"/>
        </g>
    </svg>
  )
}

